import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { setRecoil } from "recoil-nexus";
import ApiController from "../../../controller/ApiController";
import {
  CALL_TYPE_SENDER,
  INTERPHONE_STATUS_SENDER_WAIT,
  SENDER_TYPE_ROOM,
} from "../../../controller/InterphoneController";
import LogController from "../../../controller/LogController";
import { areaType } from "../../../recoil/area";
import { ChatListType, newChatListState } from "../../../recoil/chat";
import { interphoneState, MissedCallType } from "../../../recoil/interphone";
import { langState } from "../../../recoil/lang";
import { conciergeState, ConciergeStateType } from "../../../recoil/socket";
import { FooterProps } from "./type";

export const useFooter = (props: FooterProps) => {
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const missedCallList = queryClient.getQueryData<MissedCallType[]>([
    "missed-calls",
  ]);

  const deviceArea = queryClient.getQueryData<areaType | undefined>([
    "device-area",
  ]);

  const lang = useRecoilValue(langState);
  const conciergeFlag = useRecoilValue<ConciergeStateType>(conciergeState);
  const newChatListFlag = useRecoilValue<ChatListType[]>(newChatListState);

  const [isOpenDetail, setIsOpenDetail] = useState<boolean>(false);

  // API
  // 통화 요청
  const requestVoiceChat = async (missedCall: MissedCallType) => {
    try {
      LogController.click({
        path: "footer",
        params: "interphone",
        params2: `${deviceArea?.area_id}에서 부재중 통화 연결 버튼 클릭`,
        index: missedCall.sender_id,
      });

      if (deviceArea) {
        const oParams = {
          room_area_id: deviceArea.area_id,
          hotel_area_id: missedCall.sender_id,
          sender: SENDER_TYPE_ROOM,
        };

        const response = await ApiController.interphone.requestVoiceChat(
          oParams
        );

        if (response && response.data) {
          const oRes = response.data;
          console.log("requestVoiceChat", oRes);
          if (oRes.data && oRes.data.false_reason === null) {
            checkUnavailableCall(missedCall.manage_id);
            setRecoil(interphoneState, (prev) => ({
              ...prev,
              type: CALL_TYPE_SENDER,
              interphone_call_manage_id: oRes.data.interphone_call_manage_id,
              room_name: oRes.data.room_name,
              status: INTERPHONE_STATUS_SENDER_WAIT,
            }));
          } else {
            toast.error("현재 해당 구역은 통화중이에요");
          }
        }
      }
    } catch (err) {
      console.log("requestVoiceChat err-->", err);
    }
  };

  const checkUnavailableCall = async (manage_id?: number) => {
    try {
      const oParams = {
        manage_id:
          manage_id ||
          (missedCallList &&
            missedCallList.map((item) => {
              return item.manage_id;
            })),
      };

      const response = await ApiController.interphone.checkUnavailableCall(
        oParams
      );

      if (response && response.data) {
        const oRes = response.data;
        console.log("checkUnavailableCall", oRes);
        if (oRes.data && oRes.data.result && deviceArea!.area_id) {
          queryClient.fetchQuery({
            queryKey: ["missed-calls"],
            queryFn: async () =>
              ApiController.interphone
                .getUnavailableCalls({
                  receiver: SENDER_TYPE_ROOM,
                  receiver_id: deviceArea!.area_id,
                })
                .then((res) => res.data.data.unavailableCalls || []),
          });
        }
      }
    } catch (err) {
      console.log("checkUnavailableCall err-->", err);
    }
  };

  const openMissedCall = (event: any) => {
    setIsOpenDetail(true);
  };

  const conciergeCheck = () => {
    if (props.concierge?.concierge_manage?.status === 1) {
      if (props.concierge.concierge_manage.is_concierge_time_set === 0)
        return true;
      else {
        const nowDate = new Date();
        const currentMin = nowDate.getHours() * 60 + nowDate.getMinutes();

        const conciergeStartTime = props.concierge.concierge_manage.start_time
          .split(":")
          .map(Number);
        const startMin = conciergeStartTime[0] * 60 + conciergeStartTime[1];

        const conciergeEndTime = props.concierge.concierge_manage.end_time
          .split(":")
          .map(Number);
        const endMin = conciergeEndTime[0] * 60 + conciergeEndTime[1];

        console.log("time", currentMin, startMin, endMin);

        if (startMin === endMin) {
          return true;
        }

        if (startMin < endMin) {
          return currentMin >= startMin && currentMin < endMin;
        } else {
          return currentMin >= startMin || currentMin < endMin;
        }
      }
    } else if (conciergeFlag.concierge_id) {
      return true;
    } else return false;
  };

  const interphoneCheck = () => {
    return props.interphoneAreaList.length > 0 && props.useInterphone === 1;
  };

  const handleConciergeClick = () => {
    if (conciergeFlag.concierge_id) {
      setRecoil(conciergeState, { ...conciergeFlag, isChat: true });
    } else {
      props.openConciergeModal();
    }
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "click",
      params2: "프론트요청 버튼 클릭",
    });
  };

  const handleInterphoneClick = () => {
    navigate("/interphone/list");
    LogController.click({
      path: "StoreSelector(MainPage)",
      params: "click",
      params2: "호텔 내선통화 버튼 클릭",
    });
  };

  return {
    lang,
    conciergeFlag,
    newChatListFlag,
    missedCallList,
    isOpenDetail,
    openMissedCall,
    conciergeCheck,
    interphoneCheck,
    handleConciergeClick,
    handleInterphoneClick,
    requestVoiceChat,
    checkUnavailableCall,
  };
};
